import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestBillingSupportMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type RequestBillingSupportMutationPage = { readonly __typename?: 'RootMutationType', readonly requestBillingSupport: boolean };


export const RequestBillingSupportDocument = gql`
    mutation RequestBillingSupport {
  requestBillingSupport
}
    `;
export type RequestBillingSupportMutationFn = Apollo.MutationFunction<RequestBillingSupportMutationPage, RequestBillingSupportMutationVariables>;

/**
 * __useRequestBillingSupportMutation__
 *
 * To run a mutation, you first call `useRequestBillingSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBillingSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBillingSupportMutation, { data, loading, error }] = useRequestBillingSupportMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestBillingSupportMutation(baseOptions?: Apollo.MutationHookOptions<RequestBillingSupportMutationPage, RequestBillingSupportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBillingSupportMutationPage, RequestBillingSupportMutationVariables>(RequestBillingSupportDocument, options);
      }
export type RequestBillingSupportMutationHookResult = ReturnType<typeof useRequestBillingSupportMutation>;
export type RequestBillingSupportMutationResult = Apollo.MutationResult<RequestBillingSupportMutationPage>;
export type RequestBillingSupportMutationOptions = Apollo.BaseMutationOptions<RequestBillingSupportMutationPage, RequestBillingSupportMutationVariables>;